"use client"

import { Component } from "react"
import moment from "moment"
import routes from "../../routes/URL"
import API, { URL_PATH } from "../../services/API"
import redux from "../../common/Redux"
import Table from "../../components/Table"
import Header from "../../components/Header"
import Modal from "../../components/Modal"
import { getCurrency } from "../../common/util"
import Toast from "../../components/Toast"
import ConfirmationModal from "../../components/ConfirmationModal"
import axios from "axios"

const ColorScheme = {
  buttonColor: "#FFC857",
  bgColor: "#02111B",
  componentColor: "#07070A",
  accentColor: "#BB0A21",
  textColor: "#FFFFFF",
}

class ListMenuScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
      modleVisible: false,
      modalData: null,
      version: 0,
      selectedRows: [],
      isBulkDeleteConfirmationModalOpen: false,
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
    }
  }

  componentDidMount() {}

  handleToastClose = () => {
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  onDelete = async (item) => {
    console.log("sure to delete?")
    const { status, message, data } = await API(this, "post", URL_PATH.deleteInventoryInvoice(item.id))
    if (status == "success") {
      this.showToast(message, "success")
      this.setState({
        version: this.state.version + Math.random() + "",
      })
    } else {
      this.showToast(message, "error")
    }
  }

  onEdit = async (item) => {
    this.props.history.push(routes.admin.inventory.update(item.id))
  }

  onView = (item) => {
    console.log("View item:", item)
    this.setState({
      modalData: item,
      modleVisible: true,
    })
  }

  // Handle selected rows change from Table component
  handleSelectedRowsChange = (selectedRows) => {
    this.setState({ selectedRows })
  }

  // Open bulk delete confirmation modal
  openBulkDeleteConfirmationModal = () => {
    this.setState({ isBulkDeleteConfirmationModalOpen: true })
  }

  // Close bulk delete confirmation modal
  closeBulkDeleteConfirmationModal = () => {
    this.setState({ isBulkDeleteConfirmationModalOpen: false })
  }

  // Handle bulk delete confirmation
  handleBulkDeleteConfirmation = async () => {
    await this.onBulkAction(this.state.selectedRows)
    this.closeBulkDeleteConfirmationModal()
  }

  // Bulk delete action
  onBulkAction = async (rows) => {
    const ids = Object.values(rows)
    const token = localStorage.getItem("token")
    
    const { status, message, data } = await API(this, "post", URL_PATH.bulkDeleteInventory(this.props.selectedHotelId.id),{ids})
    if (status) {
      this.showToast(message, "success")
    this.setState({
          version: this.state.version + Math.random() + "",
          selectedRows: [],
        })
    } else {
      this.showToast(message, "error")
    }

  }

  // Helper component for displaying rows in the modal
  Row = ({ label, value }) => {
    return (
      <div style={{ display: "flex", marginBottom: "10px" }}>
        <div style={{ fontWeight: "bold", width: "200px" }}>{label}:</div>
        <div>{value || "N/A"}</div>
      </div>
    )
  }

  render() {
    const { modalData, modleVisible, toast, selectedRows, isBulkDeleteConfirmationModalOpen } = this.state

    return (
      <>
        <div className="container-fluid">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "15px",
            }}
          >
            <Header title={"Inventory"} button={null} />
            <div>
              {selectedRows.length > 0 && (
                <button
                  className="btn mr-2"
                  style={{
                    backgroundColor: ColorScheme.accentColor,
                    color: ColorScheme.textColor,
                    marginRight: "10px",
                  }}
                  onClick={this.openBulkDeleteConfirmationModal}
                >
                  <i className="fa fa-trash mr-1" aria-hidden="true"></i> Delete Selected ({selectedRows.length})
                </button>
              )}
              <div style={{ display: "flex", gap: "10px" }}>
              <button
                className="btn"
                style={{
                  backgroundColor: ColorScheme.buttonColor,
                  color: ColorScheme.componentColor,
                  fontWeight: "700",
                }}
                onClick={() => {
                this.props.history.push(routes.admin.inventory.create(this.props.hotels[0].hotel_slug));
              }}
              >
                + ADD INVENTORY
              </button>
              <button
  className="btn"
  style={{
    backgroundColor: "#02111B",
    color: "white",
    borderWidth: "1px",
    borderColor: "#FFC857", // also fixed missing '#' here
    borderStyle: "solid",
    fontWeight: "700",
  }}
  onClick={() => this.props.history.push(routes.admin.supplier.root)}
>
  Supplier
</button>


                

              </div>
            </div>
          </div>

          <Table
            key={this.state.version}
            api={URL_PATH.listInventory}
            noPaginate={true}
            // onRowClick={this.onView}
            export={true} 
              exportFileName="Inventory"  


            onEdit={this.props.accessControl.includes("hotel-inventory") ? this.onEdit : null}
            deleteText="delete all data related to this table."
            onDelete={this.props.accessControl.includes("hotel-inventory") ? this.onDelete : null}
            onView={this.props.accessControl.includes("hotel-inventory") ? this.onView : null}
            onSelectedRowsChange={this.handleSelectedRowsChange}
            selectedHotelId={this.props.selectedHotelId}
            row={[
              {
                title: "Date",
                key: "invoice_date",
                sortable: true,
              },
              {
                title: "Invoice number",
                key: "invoice_number",
                sortable: true,
              },
              {
                title: "Invoice amount",
                key: "invoice_amount",
                sortable: true,
                parse: (item) => {
                  // Format price with currency symbol
                  return `${getCurrency(this.props.selectedHotelId.currency)} ${item.invoice_amount}`
                },
              },
              {
                title: "Supplier",
                key: "supplier",
                sortable: false,
                parseFunction: (item) => {
                  return item.supplier_name
                },
              },
              {
                title: "Payment status",
                key: "payment_status",
                sortable: true,
                type: "paymentStatus",
                parse: (item) => {
                  if (item.payment_status === "paid") {
                    return {
                      text: "Paid",
                      bgColor: "white", // Green background
                      textColor: "green", // Blue text
                      borderColor: "#0D6EFD", // Blue border
                      icon: <i className="fa fa-check-circle" style={{ fontSize: "14px", color: "green" }} />,
                    }
                  } else {
                    return {
                      text: "Unpaid",
                      bgColor: "white", // Light red background
                      textColor: "#BB0A21", // Dark red text
                      borderColor: "#BB0A21", // Dark red border
                      icon: <i className="fa fa-times-circle" style={{ fontSize: "14px", color: "#BB0A21" }} />,
                    }
                  }
                },
              },
            ]}
          />

          {modleVisible && modalData && (
            <Modal
              visible={modleVisible}
              onClose={() => {
                this.setState({
                  modleVisible: false,
                })
              }}
              title={"Inventory Details #" + modalData.id}
            >
              <div
                style={{
                  padding: "15px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <this.Row label="Invoice Number" value={modalData.invoice_number} />
                <this.Row label="Invoice Date" value={modalData.invoice_date} />
                <this.Row
                  label="Invoice Amount"
                  value={`${getCurrency(this.props.selectedHotelId.currency)}${modalData.invoice_amount}`}
                />
                <this.Row label="Supplier" value={modalData.supplier.supplier_name} />
                <this.Row label="Payment Status" value={modalData.payment_status} />
                <this.Row label="GST" value={`${getCurrency(this.props.selectedHotelId.currency)}${modalData.gst}`} />
                <this.Row
                  label="Delivery Charge"
                  value={`${getCurrency(this.props.selectedHotelId.currency)}${modalData.delivery_charge}`}
                />
                <this.Row label="Created At" value={moment(modalData.created_at).format("DD-MM-YYYY HH:mm")} />
                <this.Row label="Updated At" value={moment(modalData.updated_at).format("DD-MM-YYYY HH:mm")} />
              </div>
            </Modal>
          )}

          {/* Bulk Delete Confirmation Modal */}
          <ConfirmationModal
            isOpen={isBulkDeleteConfirmationModalOpen}
            onConfirm={this.handleBulkDeleteConfirmation}
            onCancel={this.closeBulkDeleteConfirmationModal}
            title="Confirm Bulk Deletion"
            message={`Are you sure you want to delete the selected ${selectedRows.length} items?`}
            confirmText="Yes, delete them!"
            cancelText="Cancel"
          />

          <Toast
            open={toast.open}
            message={toast.message}
            severity={toast.severity}
            handleClose={this.handleToastClose}
          />
        </div>
      </>
    )
  }
}

export default redux(ListMenuScreen)
